module.exports = __webpack_public_path__ + "static/media/portfolio-7.5e22c151.jpg";